
"use strict"

import { menu, menuToggle } from './components/menu.js'
import { expandGroup } from './components/expand.js'
import { fadeOnScroll } from './components/fadeOnScroll.js'
import { animateOnScroll } from './components/animateOnScroll.js'
import { carousel } from './components/carousel.js'
import { socialFeed } from './components/socialFeed.js'
import { map } from './components/map.js'

import Mediabox from 'mediabox'


// init

fadeOnScroll()


// menu

const siteMenu = menu({
	menu: document.querySelector('.js-site-nav'),
	background: document.querySelector('.js-site-nav-bg')
})

const siteMenuToggle = menuToggle({
	menu: siteMenu,
	toggle: document.querySelector('.js-site-nav-toggle')
})


// expand group in site menu

expandGroup({
	context: document.querySelector('.js-site-nav'),
	expandSelector: '.js-expand', 
	toggleSelector: '.js-expand-toggle',
	contentSelector: '.js-expand-content'
})


// animate on scroll

animateOnScroll('.js-animate-on-scroll', 'animated')


// carousels 

carousel('.js-carousel', '.js-carousel__controls')


// map

map(document.querySelector('.js-map'), {
	apiKey: 'AIzaSyDLnHrx3I0CcDjvK0_crMOE8u4trcvO99M',
	clusterImages: window?.siteSettings?.templateUri && siteSettings.templateUri + "/assets/images/gmaps/" || null
})


// mediabox

Mediabox('.js-mediabox', {
	rel: 0
})


// accordions

expandGroup({
	expandSelector: '.js-expand', 
	toggleSelector: '.js-expand-toggle',
	contentSelector: '.js-expand-content'
})


// social feeds

;[...document.querySelectorAll('.js-social-feed')].map(el => socialFeed(el))
